import request from '@/utils/request'

const _Prefix = "/district"

// 查询区域字典信息列表
export function districtList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询区域字典信息详细
export function getDistrict(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增区域字典信息
export function addDistrict(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改区域字典信息
export function updateDistrict(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除区域字典信息
export function delDistrict(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}